import { NgModule } from '@angular/core';

import { AttachmentsModule } from '../attachments/attachments.module';
import { SharedModule } from '../shared/shared.module';
import { TableModule }  from '../table/table.module';
import { AddVehicleFromBranchComponent }         from './vehicle.add-from-branch.component';
import { VehicleFormDefaultComponent }           from './vehicle.form-default.component';
import { VehicleFormMarineComponent }            from './vehicle.form-marine.component';
import { VehicleFormMusicComponent }             from './vehicle.form-music.component';
import { VehicleBranchHistoryComponent }         from './vehicle.branch-history.component';
import { VehicleFollowUpNotesComponent }         from './vehicle.follow-up-notes.component';
import { VehicleFormSettingsComponent }          from './vehicle.form-settings.component';
import { VehicleHistoryActionsComponent }        from './vehicle.history.actions.component';
import { VehicleHistoryComponent }               from './vehicle.history.component';
import { VehicleHistoryReportComponent }         from './vehicle.history.report.component';
import { VehicleHistoryRowExpandComponent }      from './vehicle.history.row.expand.component';
import { VehicleInfoComponent }                  from './vehicle.info.component';
import { VehicleInvoiceItemsRowExpandComponent } from './vehicle.invoice-items.row.expand.component';
import { VehiclesListComponent }                from './vehicles.list.component';
import { VehicleTransferOwnerComponent }        from './vehicle-transfer-owner.component';
import {
  VehicleAttachmentsPlaceholderComponent,
  VehicleEventsPlaceholderComponent,
  VehicleInspectionsPlaceholderComponent,
  VehicleInvoicesPlaceholderComponent
} from './vehicle.placeholder-components';

@NgModule({
  declarations: [
    AddVehicleFromBranchComponent,
    VehicleFormDefaultComponent,
    VehicleFormMarineComponent,
    VehicleFormMusicComponent,
    VehicleAttachmentsPlaceholderComponent,
    VehicleBranchHistoryComponent,
    VehicleEventsPlaceholderComponent,
    VehicleFollowUpNotesComponent,
    VehicleFormSettingsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryComponent,
    VehicleHistoryReportComponent,
    VehicleHistoryRowExpandComponent,
    VehicleInfoComponent,
    VehicleInspectionsPlaceholderComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehicleInvoicesPlaceholderComponent,
    VehiclesListComponent,
    VehicleTransferOwnerComponent
  ],
  entryComponents: [
    AddVehicleFromBranchComponent,
    VehicleFormDefaultComponent,
    VehicleFormMarineComponent,
    VehicleFormMusicComponent,
    VehicleAttachmentsPlaceholderComponent,
    VehicleBranchHistoryComponent,
    VehicleEventsPlaceholderComponent,
    VehicleFollowUpNotesComponent,
    VehicleFormSettingsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryComponent,
    VehicleHistoryReportComponent,
    VehicleHistoryRowExpandComponent,
    VehicleInfoComponent,
    VehicleInspectionsPlaceholderComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehicleInvoicesPlaceholderComponent,
    VehiclesListComponent,
    VehicleTransferOwnerComponent
  ],
  exports: [
    VehicleAttachmentsPlaceholderComponent,
    VehicleEventsPlaceholderComponent,
    VehicleFormDefaultComponent,
    VehicleFormMarineComponent,
    VehicleFormMusicComponent,
    VehicleHistoryActionsComponent,
    VehicleInspectionsPlaceholderComponent,
    VehicleInvoicesPlaceholderComponent,
    VehiclesListComponent,
    VehicleHistoryRowExpandComponent,
    VehicleInfoComponent,
    VehicleInvoiceItemsRowExpandComponent
  ],
  imports: [
    AttachmentsModule,
    SharedModule,
    TableModule
  ]
})
export class VehiclesModule {}
